<!-- 
	This is the officials page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div class="c_department_container">
		<div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
		
		<a-row :gutter="[24]" type="flex" style="margin-top: -170px;margin-right: 2%;margin-left: 3%">
            <a-col :span="24" class="mb-24" style="padding-left: 0px;padding-right: 0px">
				<height-watcher>
                    <div
                        class="budgets-page-body"
                        slot-scope="{ height, offset }"
                        :offset="offset"
                        :style="{
                            'max-height': height - (450) + 'px',
                            height: height - (450) + 'px',
                        }"
                    >
						<a-card :bordered="false" class="card-profile-head " :bodyStyle="{padding: 0}">		
							<CardDepartmentsTable />
						</a-card>
					</div>
                </height-watcher>
			</a-col>
		</a-row>
	</div>
</template>

<script>
import CardDepartmentsTable from '../../components/Cards/CardDepartmentsTable.vue' ;
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";
export default ({
	name: "ManageDepartments",
    components: {
        CardDepartmentsTable,
		HeightWatcher
    },
   
    

})

</script>

<style lang="scss">
</style>